import React from 'react'
import { Eye, EyeSlash } from '@phosphor-icons/react'

const InputField = ({
  label = "",
  className = "w-full flex flex-wrap items-center",
  inputClassName = 'ds-input',
  labelOnTop = false,
  labelClassName = '',
  enableShowPasswordIcon = false,
  showPassword = null,
  setShowPassword = null,
  children,
  ...inputProps
}) => {
  

  return (
    <React.Fragment>
      <div className={`text-sm ${className} space-y-2`}>
        {label !== "" && (<label className={`${labelOnTop ? 'flex-grow w-full' : ''} ${labelClassName}`}>{label}</label>)}
        <div className='w-full relative flex'>
          <input
            className={`${inputClassName}`}
            {...inputProps}
          />
          {
            enableShowPasswordIcon && (
              <div className='absolute h-full flex items-center right-2 cursor-pointer'>
                {showPassword ?
                  <Eye size={24} onClick={() => setShowPassword(false)} /> :
                  <EyeSlash size={24} onClick={() => setShowPassword(true)} />
                }
              </div>
            )
          }
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default InputField